/**
 * Role checks shared by the admin UI.
 *
 * These gate what is *rendered*. The server is the real authority — every
 * guarded mutation re-checks — but the two lists have to agree, or an admin
 * gets a button that always fails.
 */

// Mirrors isAdmin() in fyrstup-server/src/utils/common.js.
const ADMIN_ROLES = ["SUPER_ADMIN", "ADMIN", "ADMIN 1"];

/** Only a broker (company admin) books an agent onto an open house. */
export const canAssignOpenHouseHost = (user) =>
  ADMIN_ROLES.includes(user?.role?.name);

/** The signed-in user as stored at login, or null when signed out. */
export const currentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("userInfo")) || null;
  } catch {
    return null;
  }
};
